import React from 'react';
import './detailBoxLargeCompany.css'
import { checkOrangeIcon, circleIcon } from '../../../../utils/icons';

const BenefitsBoxCompany = ({ title, data, checkedBenefits }) => {
  
  const normalizeString = (str) => {
    // Convert to lowercase and remove spaces
    return str.toLowerCase().replace(/\s+/g, '');
  };
  
  const benefitMapping = {
    'descuentoscorporativos': 'Descuentos corporativos',
    'cumpleanoslibre': 'Cumpleaños libre',
    'conveniosexternos': 'Convenios externos',
    'contratoscorporativos': 'Contratos corporativos',
    'colacion': 'Colación',
    'formacion': 'Formación',
    'seguro': 'Seguro',
    'traslado': 'Traslado',
    'uniforme': 'Uniforme',
    'capacitación': 'Capacitaciones',
    'otras': 'Otras'
  };
  
  // Reverse mapping: display name -> camelCase key
  const reverseBenefitMapping = {
    'Seguro': 'seguro',
    'Traslado': 'traslado',
    'Uniforme': 'uniforme',
    'Capacitaciones': 'capacitación',
    'Colación': 'colación',
    'Formación': 'formación',
    'Cumpleaños libre': 'cumpleañosLibre',
    'Convenios externos': 'conveniosExternos',
    'Descuentos corporativos': 'descuentosCorporativos',
    'Contratos corporativos': 'contratosCorporativos',
    'Otras': 'otras'
  };
  
  // Handle case where benefits come as numbers (indices) instead of names
  const benefitNames = [
    'seguro', 'traslado', 'uniforme', 'capacitación', 'colación', 
    'formación', 'cumpleañosLibre', 'conveniosExternos', 
    'descuentosCorporativos', 'contratosCorporativos', 'otras'
  ];
  
  // Convert benefits from numbers to names if needed
  const normalizedCheckedBenefits = checkedBenefits ? checkedBenefits.map(benefit => {
    // If benefit is a number (index), convert to benefit name
    if (typeof benefit === 'string' && /^\d+$/.test(benefit)) {
      const index = parseInt(benefit);
      return benefitNames[index] || benefit;
    }
    return benefit;
  }) : [];
    
  return (
    <div className='box-large-company__benefits-container'>
      <h3>{title}</h3>
      <ul className="box-large-company__grid-box-container">
        {data.map((value, index) => {
          // Get the camelCase key for this display name
          const camelCaseKey = reverseBenefitMapping[value];
          // Check if this benefit is selected using normalized benefits
          const isSelected = normalizedCheckedBenefits && normalizedCheckedBenefits.includes(camelCaseKey);
                    
          return (
            <li key={index} className='box-large-company__icon-value-container'>
              {isSelected ? checkOrangeIcon : circleIcon}
              <div className="box-large-company__value-container">
                  {value}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  )
};

export default BenefitsBoxCompany;
